export default __webpack_public_path__ + "static/media/curve_desktop.543783b0.svg";